import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Card, CardContent, CardHeader, Collapse, IconButton, List, ListItem, ListItemText, Stack } from "@mui/material";
import TatPermissionsCard from "./TatPermissionsCard";
import { IPermissionModel } from "../../../../common/models/IPermissionModel";
import PermissionsAvatar from "./PermissionsAvatar";

export type PermissionsCardProps = {
    permissionModel: IPermissionModel;
    detailExpanded: boolean;
    onToggleDetailExpanded?: () => void;
};

export default function PermissionsCard({
    permissionModel,
    detailExpanded,
    onToggleDetailExpanded
}: PermissionsCardProps) {

    return (
        <Card variant="elevation" elevation={2}>
            <CardHeader
                sx={{
                    padding: 1
                }}
                title={
                    permissionModel.targetObject.displayText
                }
                avatar={<PermissionsAvatar />}
                subheader={
                    permissionModel.summary
                }
                action={
                    permissionModel.hasDetail &&
                    <IconButton
                        sx={{
                            color: "text.primary"
                        }}
                        onClick={() => onToggleDetailExpanded && onToggleDetailExpanded()}
                        style={{
                            marginTop: 8
                        }}
                    >
                        <ExpandMoreIcon
                            sx={{
                                transform: !detailExpanded ? "rotate(0deg)" : "rotate(180deg)",
                                transition: theme => theme.transitions.create('transform', {
                                    duration: theme.transitions.duration.shortest,
                                })
                            }}
                        />
                    </IconButton>
                }
            />

            <Collapse in={detailExpanded} timeout="auto">
                <CardContent sx={{
                    padding: theme => `0 ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)} !important`
                }}>
                    <List
                        sx={{
                            padding: 0,
                            marginLeft: 8
                        }}
                    >
                        {permissionModel.hasDetail &&
                            permissionModel.summaryDetail?.map((o, index) => {
                                return (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            padding: 0
                                        }}
                                    >
                                        <ListItemText
                                            secondary={
                                                `${o.Key}: ${o.Value}`
                                            }
                                        >
                                        </ListItemText>
                                    </ListItem>
                                );
                            })}
                    </List>
                </CardContent>
            </Collapse>

            {(permissionModel.tatPermissions?.length ?? 0) > 0 &&
                <Stack
                    direction="column"
                    spacing={1}
                    sx={{
                        padding: 2,
                        paddingTop: 0
                    }}
                >
                    {permissionModel.tatPermissions?.map((tat, index) => {
                        return (
                            <TatPermissionsCard
                                key={index}
                                tatPermissions={tat}
                            />
                        );
                    })}
                </Stack>
            }
        </Card>
    );
}
